"use client";

import WordCard from "~/app/(private)/words/Card";
import { type OnShowFullCard } from "~/app/(private)/words/CardFullProvider";
import WordGridContainer from "~/app/(private)/words/WordGridContainer";
import { Furigana } from "~/components/common/Furigana";
import { type SelectTranscriptWithLexemes } from "~/server/db/transcripts/schema";
import { useTrackLemmas } from "~/state/lemmas/hooks/useTrackLemmas";

export default function Transcript({
  isMobile,
  transcript,
  showKnownLemmas,
  onShowFullCard,
}: {
  isMobile: boolean;
  transcript: SelectTranscriptWithLexemes;
  showKnownLemmas: boolean;
  onShowFullCard: OnShowFullCard;
}) {
  const { isLemmaTracked } = useTrackLemmas();

  const userLexemes = transcript.lexemes.filter(({ lexeme }) => {
    if (showKnownLemmas) return true;
    return !isLemmaTracked(lexeme.lemmaId);
  });

  return (
    <>
      <div className="mb-4 text-center text-sm text-muted-foreground">
        <Furigana rubyContent={transcript.textFurigana ?? ""} />
      </div>
      <WordGridContainer>
        {userLexemes.map((userLexeme, index) => (
          <WordCard
            isMobile={isMobile}
            lemma={userLexeme.lexeme.lemma}
            lexeme={userLexeme.lexeme}
            key={`${userLexeme.id}-${transcript.id}-${index}`}
            transcript={transcript}
            onShowFullCard={onShowFullCard}
          />
        ))}
      </WordGridContainer>
    </>
  );
}
